import * as React from "react";
import {Confirm}   from "./confirm/confirm";
import {Error}     from "./error/error";
import {TestRoute} from "./test/test";

export const SsoRoutes = ({next}) => next([
    {
        path: "/sso/confirm",
        component: Confirm,
    },
    {
        path: "/sso/error",
        component: Error,
    },
    {
        path: "/sso/test",
        component: TestRoute,
    }
]);
